import { useMemo, useState } from 'react';

import config from '@/config';
import useCache from '@/hooks/useCache';
import useTranslations from '@/i18n/useTranslations';
import InfoIcon from '@/shared-components/icons/components/public/InfoIcon';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import SettingsLoadingPage from '@/shared-components/loaders/components/SettingsLoadingPage';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import SettingsHeading from '@/shared-components/text/components/SettingsHeading';
import Text from '@/shared-components/text/components/Text';

import BankAccountForm from './components/BankAccountForm';

import './index.css';

export default function BankAccount() {
  const t = useTranslations('common.user_settings.bank_account');
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const { loading: bankLoading, fetchData, setFetchData } = useCache("bank_account_details", `${config.apis.api.url}/gallery/bank`, {
    injectToken: true
  });
  const { loading: galleryInfoLoading, fetchData: galleryInfo } = useCache("bank_account_gallery_info", `${config.apis.api.url}/gallery/info`, {
    injectToken: true
  });

  const headingAction = useMemo(() => (
    <div className="settings-bank-account__info">
      <button
        type="button"
        className="settings-bank-account__info-button"
        onClick={() => setIsInfoOpen(true)}
        aria-label="Payments profile information"
      >
        <InfoIcon className="settings-bank-account__info-icon" />
      </button>
      <GenericPopup
        open={isInfoOpen}
        className="generic-popup_content remove-scrollbar settings-bank-account__info-popup"
        opacity
      >
        <div className="generic-popup__header settings-bank-account__info-popup-header">
          <Text className="generic-popup__header-text-theme">
            {t('heading')}
          </Text>
          <XIcon className="generic-popup__close" onClick={() => setIsInfoOpen(false)} />
        </div>
        <div className="settings-bank-account__info-list">
          <section className="settings-bank-account__info-item">
            <h3>{t('form.stripe.connection_details.title')}</h3>
            <p>{t('description')}</p>
          </section>
          <section className="settings-bank-account__info-item">
            <h3>{t('form.stripe.payout_timing.title')}</h3>
            <p>{t('form.stripe.payout_timing.description')}</p>
          </section>
          <section className="settings-bank-account__info-item">
            <h3>{t('form.stripe.currency_fx.title')}</h3>
            <p>{t('form.stripe.currency_fx.description')}</p>
          </section>
          <section className="settings-bank-account__info-item">
            <h3>{t('form.tax.id_number_title')}</h3>
            <p>{t('form.tax.id_number_info')}</p>
          </section>
        </div>
      </GenericPopup>
    </div>
  ), [isInfoOpen, t]);

  if(bankLoading || galleryInfoLoading) {
    return (
      <SettingsLoadingPage page={t('heading')}/>
    );
  } else {
    return (
      <>
        <SettingsHeading text={t('heading')} action={headingAction}/>
        <div className="settings-bank-account__container">
          <BankAccountForm
            fetchData={fetchData}
            setFetchData={setFetchData}
            galleryBusinessId={galleryInfo?.gallery_business_id}
          />
        </div>
      </>
    );
  }
}
